var map = {
	"./baac.svg": "3tsG",
	"./bay.svg": "mtng",
	"./bbl.svg": "DkTV",
	"./bnp.svg": "JTX2",
	"./boa.svg": "0kEC",
	"./cacib.svg": "SGAc",
	"./cimb.svg": "DIIi",
	"./citi.svg": "7CzI",
	"./co.th.promptpay.qr.svg": "Yrg9",
	"./co.th.truemoney.wallet.svg": "+dsa",
	"./db.svg": "Cm6Y",
	"./ghb.svg": "IizR",
	"./gsb.svg": "ax4F",
	"./hsbc.svg": "Y04M",
	"./ibank.svg": "k2zf",
	"./icbc.svg": "hRZE",
	"./jpm.svg": "auK7",
	"./kbank.svg": "Xl/4",
	"./kk.svg": "x1BP",
	"./ktb.svg": "eJ0r",
	"./lhb.svg": "XkSF",
	"./mb.svg": "le+D",
	"./mega.svg": "CB0h",
	"./mufg.svg": "IAjv",
	"./rbs.svg": "yrzT",
	"./sc.svg": "vIuT",
	"./scb.svg": "1elH",
	"./smbc.svg": "uBqW",
	"./tbank.svg": "13w0",
	"./tcrb.svg": "lnUu",
	"./tisco.svg": "XEZ5",
	"./tmb.svg": "lptV",
	"./uob.svg": "InA8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CNtG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bank_logo nonrecursive \.svg$
// module id = CNtG
// module chunks = 18 19